import GoogleMapsService from '../../../shared/services/GoogleMapsService';

export async function geocodeLocationAddress(
  address: string,
): Promise<{ latitude: number; longitude: number } | null> {
  const trimmed = String(address || '').trim();
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!trimmed || !apiKey || apiKey === 'YOUR_API_KEY') return null;
  if (!GoogleMapsService.isApiLoaded()) await GoogleMapsService.load(apiKey);
  if (!window.google?.maps?.Geocoder) return null;
  const geocoder = new window.google.maps.Geocoder();
  return new Promise((resolve) => {
    geocoder.geocode({ address: trimmed }, (results: any[], status: string) => {
      const point = results?.[0]?.geometry?.location;
      if (status !== 'OK' || !point) {
        resolve(null);
        return;
      }
      resolve({ latitude: point.lat(), longitude: point.lng() });
    });
  });
}
